<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="CustomerLevelsList"
          :extra-items="[
            {
              text: customerLevel.name,
              to: 'CustomerLevelsView',
              params: { id: this.$route.params.id },
            },
            '會員等級列表'
          ]" />
      </div>
    </div>
    <b-overlay :show="isFetching">
      <b-card>
        <h4 class="mb-2 mb-xl-0 mr-2 font-weight-bold">{{ `已擁有${customerLevel.name}會員等級的會員` }}</h4>

        <div class="d-flex justify-content-end align-items-center">
          <b-dropdown
            class="flex-shrink-0 mr-2"
            variant="inverse-info"
          >
            <template #button-content>
              <span class="mdi mdi-download"></span> 資料匯出
            </template>
            <b-dropdown-item @click="exportCustomers('excel')">下載 EXCEL</b-dropdown-item>
            <b-dropdown-item @click="exportCustomers('csv')">下載 CSV</b-dropdown-item>
          </b-dropdown>
          <b-button
            variant="inverse-info"
            class="flex-shrink-0 mb-2 mb-xl-0 mr-2"
            :to="{ name: 'CustomerLevelsLog', params: { id: $route.params.id } }"
          >
            <span class="mdi mdi-note-multiple"></span>異動紀錄
          </b-button>
          <b-button
            v-if="customerLevel.is_line_module"
            variant="inverse-info"
            class="flex-shrink-0 mb-2 mb-xl-0 mr-2"
            @click="showImportModal"
          >
           <span class="mdi mdi-cloud-upload"></span> 批次上傳
          </b-button>
          <StaffAddCustomer
            ref="staffAddCustomer"
            add-button-text="加入會員"
            @bind="bindCustomer"
            :sourceType="customerMerchantType"
          ></StaffAddCustomer>
        </div>

        <div class="row">
          <div class="col-12">
            <b-table
              striped
              hover
              responsive
              :items="customers"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :no-local-sorting="true"
              @sort-changed="handleSort"
            >
              <template #cell(avatar_url)="data">
                <div class="d-flex align-items-center justify-content-center">
                  <router-link :to="{ name: 'CustomerDetailView', params: { customerID: data.item.id } }" >
                    <b-avatar
                      :src="data.item.avatar_url"
                      variant="secondary"
                      size="2rem"
                    ></b-avatar>
                  </router-link>
                </div>
              </template>
              <template #cell(name)="data">
                <router-link :to="{ name: 'CustomerDetailView', params: { customerID: data.item.id } }" >{{ data.item.name | hiddenString(20) }}</router-link>
              </template>
              <template #cell(logs[0].start_at)="data">
                {{ formatDate(data.item.logs?.[0]?.start_at) }}
              </template>
              <template #cell(logs[0].end_at)="data">
                {{ formatDate(data.item.logs?.[0]?.end_at) }}
              </template>
              <template #cell(logs[0].created_at)="data">
                {{ formatDate(data.item.logs?.[0]?.created_at) }}
              </template>
              <template #cell(action)="data">
                <div class="d-flex justify-content-center">
                  <b-button class="mr-2" variant="inverse-info" size="sm" v-b-modal="'modal-choose-customer-time'" @click="chooseCustomerTime(data.item)">
                    設定
                  </b-button>
                  <b-button variant="inverse-danger" size="sm" v-b-modal="'modal-edit-customer-level'" @click="editCustomerLevel(data.item)">
                    等級異動
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </div>

        <CustomPagination
          :currentPage="query.page"
          :totalRows="totalRows"
          :perPage="query.per_page"
          @page-change="handlePageChange"
          @per-page-change="handlePerPageChange"
        />
      </b-card>
    </b-overlay>
    <b-modal id="modal-batch-assign" title="批次匯入">
      <b-overlay :show="showLoadingUpload">
        <template v-if="batchAssignStep == 1">
          <div class="form-group">
            <p class="text-danger">依 LINE ID、手機號碼 順序比對會員</p>
            <b-form-file plain v-model="batchAssignFile"  placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
            <b-button
              class="mt-2"
              size="sm"
              variant="outline-primary"
              href="/excel/batch_assign_redeem_code.xlsx"
            >
              <i class="fa fa-file-text"></i>下載範例檔案
            </b-button>
          </div>
        </template>
        <template v-else-if="batchAssignStep == 2">
          <div class="form-group">
            <p>
              上傳資料筆數：{{ importCustomerPreview.total_member_count }}<br/>
              對應會員數量：{{ importCustomerPreview.valid_member_count }}<br/>
            </p>
            <p v-if="importCustomerPreview.valid_member_count != importCustomerPreview.total_member_count" class="text-danger">
              上傳資料數量與對應會員數量不同，請問是否確定匯入
            </p>
          </div>
        </template>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button variant="outline-danger" size="sm" class="float-right" @click="cancel()">
          取消
        </b-button>
        <b-button
          v-if="batchAssignStep == 1"
          size="sm"
          variant="outline-primary"
          @click="previewCustomer"
        >
          下一步
        </b-button>
        <b-button v-if="batchAssignStep == 2" size="sm" variant="outline-primary" @click="goBackBatchAssign">回上一步</b-button>
        <b-button
          v-if="batchAssignStep == 2"
          size="sm"
          variant="outline-primary"
          @click="importCustomer"
        >
          確定匯入
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-choose-customer-time"
      :title="customerTimeTitle"
      centered
      @hidden="resetModal"
      @ok="handleChooseCustomerTime"
    >
      <form ref="form" @submit.stop.prevent="handleChooseCustomerTime">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="* 開始時間"
        >
          <div class="row">
            <div class="col-12 col-xl-6">
              <datepicker
                placeholder="選擇日期"
                v-model="startAt.date"
                bootstrap-styling
                format="yyyy-MM-dd"
                :language="zh"
                :input-class="v$.startAt.date.$error ? 'is-invalid' : ''"
                @selected="onStartDateSelected"
              ></datepicker>
              <b-form-invalid-feedback :state="!v$.startAt.date.$error">
                此欄位為必填
              </b-form-invalid-feedback>

            </div>

            <div class="col-12 col-xl-6">
              <vue-timepicker
                placeholder="選擇時間"
                :input-class="[
                              'form-control',
                              {
                                'is-invalid':
                                  v$.startAt.time.HH.$error ||
                                  v$.startAt.time.mm.$error
                              },
                            ]"
                v-model="startAt.time"
                disabled
              ></vue-timepicker>
              <b-form-invalid-feedback
                :state="!v$.startAt.time.HH.$error || !v$.startAt.time.mm.$error"
              >
                此欄位為必填
              </b-form-invalid-feedback>
            </div>
          </div>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="isEndAtRequired ? '* 結束時間' : '結束時間'"
        >
          <div class="row">
            <div class="col-12 col-xl-6">
              <datepicker
                placeholder="選擇日期"
                v-model="endAt.date"
                bootstrap-styling
                clear-button
                format="yyyy-MM-dd"
                :language="zh"
                :input-class="v$.endAt.date.$error ? 'is-invalid' : ''"
                @selected="onEndDateSelected"
              ></datepicker>
              <b-form-invalid-feedback :state="!v$.endAt.date.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </div>

            <div class="col-12 col-xl-6">
              <vue-timepicker
                placeholder="選擇時間"
                :input-class="[
                              'form-control',
                              {
                                'is-invalid':
                                  v$.startAt.time.HH.$error ||
                                  v$.startAt.time.mm.$error,
                              },
                            ]"
                v-model="endAt.time"
                disabled
              ></vue-timepicker>
              <b-form-invalid-feedback
                :state="!v$.endAt.time.HH.$error || !v$.endAt.time.mm.$error"
              >
                此欄位為必填
              </b-form-invalid-feedback>
            </div>
          </div>
        </b-form-group>
      </form>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel()">
          取消
        </b-button>
        <b-button size="sm" variant="success" @click="ok()">
          確認送出
        </b-button>
      </template>
    </b-modal>
    <!-- edit level modal -->
    <b-modal
      id="modal-edit-customer-level"
      title="會員等級異動"
      centered
      @hidden="resetModal"
      @ok="handleEditCustomerLevel"
    >
      <h4>{{ modalSelectedCustomer?.name ?? "" }} 目前等級為 {{ customerLevel.name }}</h4>
      <p>請選擇會員新等級</p>

      <form ref="form" @submit.stop.prevent="handleEditCustomerLevel">
        <b-form-group>
          <b-form-select v-model="modalSelectedCustomerNewLevelId">
            <b-form-select-option
              v-for="level in enabledLevels"
              :key="level.value"
              :value="level.value"
              :disabled="level.value === customerLevel.id"
            >
              {{ level.text }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </form>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel()">
          取消
        </b-button>
        <b-button size="sm" variant="success" @click="ok()">
          確定異動
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { zh } from "vuejs-datepicker/dist/locale";
import { BAvatar } from "bootstrap-vue";
import customerLevelApi from "@/apis/customer-levels";
import StaffAddCustomer from "@/pages/Dashboard/Staff/StaffAddCustomer.vue";

import "bootstrap-vue/dist/bootstrap-vue.css";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { paginationMixin } from "@/mixins/pagination";
import { updateQueryFromRoute, updateUrl } from "@/utils/updateUrl";
import {mapGetters, mapState} from "vuex";
import {format, set} from "date-fns";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import Swal from "sweetalert2";
import deepGet from "@/utils/deepGet";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    CustomPagination,
    BAvatar,
    StaffAddCustomer,
    Datepicker,
    VueTimepicker,
    BreadCrumb
  },
  mixins: [paginationMixin],
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    const endAtValidation = this.isEndAtRequired
      ? {
          date: { required },
          time: {
            HH: { required },
            mm: { required },
          },
        }
      : {
          date: {},
          time: {
            HH: {},
            mm: {},
          },
        };

    return {
      startAt: {
        date: {
          required
        },
        time: {
          HH: { required },
          mm: { required },
        },
      },
      endAt: endAtValidation,
    };
  },
  data() {
    return {
      zh,
      totalRows: 0,
      isFetching: false,
      customerLevel: {
        name: "",
      },
      showLoadingUpload: false,
      batchAssignFile: null,
      batchAssignStep: 1,
      importCustomerPreview: {
        total_member_count: 0,
        valid_member_count: 0,
      },
      customers: [],
      baseFields: [
        { key: "avatar_url", label: "" },
        { key: "name", label: "LINE 名稱" },
        { key: "logs[0].start_at", label: "會籍開始日", sortable: true, sortKey: "customer_level_logs.start_at" },
        { key: "logs[0].end_at", label: "會籍結束日", sortable: true, sortKey: "customer_level_logs.end_at" },
        { key: "logs[0].created_at", label: "加入日期", sortable: true, sortKey: "customer_level_logs.created_at" },
      ],
      fields: [],
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
        sort_by: "customer_level_logs.created_at",
        order_by: "desc",
      },
      customerMerchantType: "line",
      selectedCustomer: null,
      customerTimeTitle: null,
      startAt: {
        date: null,
        time: {
          HH: null,
          mm: null,
        },
      },
      endAt: {
        date: null,
        time: {
          HH: null,
          mm: null,
        },
      },
      isSubmit: false,
      modalSelectedCustomer: null,
      modalSelectedCustomerNewLevelId: null,
      enabledLevels: []
    };
  },

  created() {
    this.query = updateQueryFromRoute(
      this.$route,
      this.$store,
      this.query
    );
  },

  mounted() {
    this.customerMerchantType = this.getModuleConfig("customer", "customer_level.customer_merchant_type") ?? 'line'
    this.fetchCustomerLevel();
    this.fetchCustomers();

    this.fields = this.baseFields
                      .concat(this.getModule("customer") ? [] : this.getDefaultCustomerFields())
                      .concat(this.normalizeProfileFields())
                      .concat({ key: "action", label: "操作" });

    this.fetchEnabledLevels();
    this.initialized = true;
  },

  computed: {
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    sortBy: {
      get() {
        const field = this.baseFields.find((f) => f.sortKey === this.query.sort_by);
        return field?.key || this.query.sort_by;
      },
      set() {}
    },
    sortDesc: {
      get() {
        return this.query.order_by === "desc";
      },
      set() {}
    },
    isEndAtRequired() {
      // 當 renew_month 不為 null 時，結束時間為必填
      return this.customerLevel?.renew_month !== null;
    },
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
      getModule: "dashboardModule/getModule",
    }),
    ...mapState("general", {
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
  },

  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrl(this.query, this.$store, this.$router);
      },
    },
    $route(to) {
      if (!this.initialized) return;
      this.query = { ...to.query };
      this.fetchCustomers();
    },
    selectedCustomer: {
      handler(newVal) {
        if (newVal) {
          // 當 selectedCustomer 改變時，更新 customerTimeTitle
          this.customerTimeTitle = `${newVal.name} - ${this.customerLevel.name} 會員期限設定`;
        } else {
          // 如果選擇的客戶被清空
          this.customerTimeTitle = null;
        }
      },
      immediate: true, // 初次進入時也執行一次
    },
    "endAt.date": {
      handler(newVal) {

        this.endAt.time = newVal === null ? {
          HH: null,
          mm: null,
        } : {
          HH: "23",
          mm: "59",
        };
      },
    },
  },

  methods: {
    deepGet,
    formatDate(dateString) {
      if (!dateString) return "";
      return format(new Date(dateString), "yyyy-MM-dd HH:mm");
    },
    handleSort(ctx) {
      const field = this.baseFields.find((f) => f.key === ctx.sortBy);
      this.query.sort_by = field?.sortKey || ctx.sortBy;
      this.query.order_by = ctx.sortDesc ? "desc" : "asc";
      this.handlePageReset();
    },
    showBatchAssignModal() {
      this.batchAssignStep = 1;
      this.$bvModal.show('modal-batch-assign')
    },
    async fetchCustomerLevel() {
      const { data } = await customerLevelApi.show(
        this.$route.params.id
      );
      this.customerLevel = data.data
    },
    async fetchCustomers() {
      try {
        this.isFetching = true;
        const { data } = await customerLevelApi.getCustomers(
          this.$route.params.id,
          { ...this.query }
        );
        this.customers = data.data;
        this.totalRows = data.meta.total;
      } catch (e) {
        console.log(e)
      }
      this.isFetching = false
    },
    async fetchEnabledLevels() {
      try {
        const { data } = await customerLevelApi.list({
          is_enabled: true,
          per_page: 100,
        });

        this.enabledLevels = [
          ...data.data.map((level) => {
            return {
              text: level.name,
              value: level.id,
            };
          }),
        ];

        this.modalSelectedCustomerNewLevelId = this.enabledLevels.length > 0 ? this.enabledLevels[0].value : null;
      } catch (e) {
        console.log(e)
      }
    },
    async exportCustomers(type) {
      try {
        this.isFetching = true;
        let params = { type: type === 'csv' ? 'csv' : 'excel' };
        await customerLevelApi.exportCustomers(this.$route.params.id, params).then(() => {
          this.$swal({
            title: '成功',
            text: "可至“我的主控台”查看紀錄及下載檔案",
            showCancelButton: true,
            cancelButtonText: '確認',
            type: 'success',
            confirmButtonText: '前往查看',
          }).then((result)=>{
              if (result.value) {
                this.$router.push({
                  name: "MyConsoleDownloadFileList",
                  params: { org_code: this.$route.params.org_code },
                });
              }
            });
        });
      } catch (e) {
        console.log(e)
      }
      this.isFetching = false
    },
    async bindCustomer(customer) {
      this.$swal({
        title: "確定要加入會員嗎",
        html: `
          <div class="d-block">
            <div class="my-3 text-left">
              <div>消費者姓名:${customer.name}</div>
            </div>
          </div>`,
        type: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "返回",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "確認加入",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.doBindCustomer(customer)
          } catch (e) {
            console.log(e)
          } finally {
            this.$refs.staffAddCustomer.refreshSearch()
            this.$refs.staffAddCustomer.closeModal()
          }
        }
      })
    },
    async doBindCustomer(customer, levelId = null) {
      levelId = levelId ?? this.$route.params.id;
      this.isFetching = true
      try {
        await customerLevelApi.bindCustomer(levelId, customer.id)
        await this.fetchCustomers()
      } catch (error) {
        console.error(error);

        this.$swal(
          "加入失敗",
          `${customer.name} 加入失敗`,
          "warning"
        );
        throw error;
      } finally {
        this.isFetching = false
      }
    },
    editCustomerLevel(customer) {
      this.modalSelectedCustomer = customer;
    },
    async handleEditCustomerLevel(bvModalEvt) {
      bvModalEvt.preventDefault();
      if(!this.modalSelectedCustomerNewLevelId) {
        alert('請選擇會員等級');
        return;
      }

      try {
        await this.doBindCustomer(this.modalSelectedCustomer, this.modalSelectedCustomerNewLevelId);

        this.$swal.fire({
          title: '異動完成',
          type: 'success',
        });
      } catch (error) {
        console.log(error)
      }

      this.$nextTick(() => {
        this.$bvModal.hide("modal-edit-customer-level");
      });

      this.resetModal();
    },
    showImportModal() {
      this.batchAssignStep = 1;
      this.$bvModal.show('modal-batch-assign')
    },
    importFailHandler(e) {
      console.error(e);
      if (e.response.status === 422 && e.response.data.message[0]) {
        this.$swal.fire({
          title: "檔案內容有誤",
          type: "error",
          text: e.response.data.message[0] ?? null,
        });
      } else {
        this.$swal.fire({
          title: "上傳失敗",
          type: "error",
        });
      }
    },
    goBackBatchAssign() {
      this.batchAssignFile = null
      this.batchAssignStep = 1
    },
    async previewCustomer() {
      this.showLoadingUpload = true;
      let formData = new FormData();
      formData.append("file", this.batchAssignFile);

      try {
        let { data } = await customerLevelApi.importCustomerPreview(this.$route.params.id, formData);
        this.importCustomerPreview.total_member_count = data.data.total_members;
        this.importCustomerPreview.valid_member_count = data.data.total_valid_members;

        this.batchAssignStep = 2;
      } catch (e) {
        this.importFailHandler(e)
      } finally {
        this.showLoadingUpload = false;
      }
    },

    chooseCustomerTime(data) {
      this.v$.$reset();
      this.selectedCustomer = data;

      if (data?.logs?.[0]) {
        const log = data.logs[0];

        if (log.start_at) {
          this.startAt = this.dateStringToDate(log.start_at);
        }

        if (log.end_at) {
          this.endAt = this.dateStringToDate(log.end_at);
        }
      }
    },

    async importCustomer() {
      this.showLoadingUpload = true;
      let formData = new FormData();
      formData.append("file", this.batchAssignFile);

      try {
        await customerLevelApi.importCustomer(this.$route.params.id, formData);
        this.$swal.fire({ title: "上傳成功", type: "success" });

        this.fetchCustomers()
      } catch (e) {
        this.importFailHandler(e)
      } finally {
        this.showLoadingUpload = false;
        this.$bvModal.hide("modal-batch-assign");
      }
    },

    resetModal() {
      this.v$.$reset();
      this.selectedCustomer = null;
      this.startAt = {
        date: null,
        time: {
          HH: null,
          mm: null,
        },
      };
      this.endAt = {
        date: null,
        time: {
          HH: null,
          mm: null,
        },
      };
      this.isSubmit = false;
      this.modalSelectedCustomer = null;
      this.modalSelectedCustomerNewLevelId = this.enabledLevels.length > 0 ? this.enabledLevels[0].value : null;
    },

    async handleChooseCustomerTime(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.isSubmit = true;

      const result = await this.v$.$validate();

      if (!result) return;

      let startAt = this.formatDatetime(this.startAt);

      // 判斷結束時間是否有填寫
      const hasEndAt = this.endAt.date && this.endAt.time.HH && this.endAt.time.mm;
      let endAt = hasEndAt ? this.formatDatetime(this.endAt) : null;

      // 只有當結束時間有填寫時才檢查日期順序
      if (hasEndAt) {
        let startDate = new Date(startAt.replace(" ", "T"));
        let endDate = new Date(endAt.replace(" ", "T"));

        if (startDate > endDate) {
          this.$swal(
            "錯誤",
            '開始時間不得大於結束時間',
            "error"
          );

          return;
        }
      }

      let customerId = this.selectedCustomer.id;
      let levelId    = this.customerLevel.id;
      let response = await customerLevelApi.upCustomerLevelLogLogTime(
        levelId,
        {
          customer_id : customerId,
          start_at    : startAt,
          end_at      : endAt
        }
      );

      this.showLoadingUpload = false;

      if (response.status !== 200) {
        Swal.fire({
          title: '錯誤',
          type: 'error',
          text: '更新失敗'
        })
        return;
      }

      this.resetModal();
      this.fetchCustomers();
      this.$bvModal.hide("modal-choose-customer-time");
    },

    formatDatetime(datetime) {
      return format(
        set(new Date(datetime.date), {
          hours: Number(datetime.time.HH),
          minutes: Number(datetime.time.mm),
          seconds: 0,
        }),
        "yyyy-MM-dd HH:mm:ss"
      );
    },

    dateStringToDate(dateString) {
      if (!dateString) {
        return {
          date: null,
          time: {
            HH: null,
            mm: null,
          },
        };
      }

      const dateTime = new Date(dateString);

      if (isNaN(dateTime.getTime())) {
        console.error("Invalid date string:", dateString);
        return {
          date: null,
          time: {
            HH: null,
            mm: null,
          },
        };
      }

      return {
        date: `${dateTime.getFullYear()}-${String(dateTime.getMonth() + 1).padStart(2, "0")}-${String(dateTime.getDate()).padStart(2, "0")}`,
        time: {
          HH: String(dateTime.getHours()).padStart(2, "0"),
          mm: String(dateTime.getMinutes()).padStart(2, "0"),
        },
      };
    },
    normalizeProfileFields() {
      const customerList = this.getModuleConfig("customer", "member.customer_list");

      const profileMappings =
        customerList?.find(
          (list) => list.merchant_type.toUpperCase() == this.defaultMerchantType
        )?.member_fields ?? [];

      if (profileMappings) {
        return profileMappings.map((mapping) => {
          if (mapping.matched_key.startsWith("extra.")) {
            const key = mapping.matched_key.split("extra.")[1];
            return {
              key: `profiles.${key}`,
              label: mapping.title,
            };
          } else {
            return {
              key: mapping.matched_key,
              label: mapping.title,
            };
          }
        });
      } else {
        return [];
      }
    },
    getDefaultCustomerFields() {
      return [
        { key: "outer_code", label: "識別編號" },
        { key: "mobile_phone", label: "手機" },
        { key: "email", label: "Email" },
      ];
    },
    /**
     * 當選擇開始日期時，自動填入 00:00
     */
    onStartDateSelected() {
      this.startAt.time = {
        HH: "00",
        mm: "00",
      };
    },
    /**
     * 當選擇結束日期時，自動填入 23:59
     */
    onEndDateSelected() {
      this.endAt.time = {
        HH: "23",
        mm: "59",
      };
    },
  },
};
</script>

<style scoped>
  /* 讓內部 <input> 的樣式隨驗證狀態改變 */
  .vue__time-picker input.is-invalid {
    border-color: red !important;
  }
  .d-flex >>> .dropdown .btn {
    padding-top: 0.2rem !important;
    padding-bottom: 0.23rem !important;
  }
</style>

<style>
  /* 讓 disabled 狀態的時間選擇器字體保持清晰 - 使用全域樣式 */
  .vue__time-picker input:disabled,
  .vue__time-picker input[disabled],
  .vue__time-picker .form-control:disabled,
  input.form-control:disabled {
    color: #495057 !important;
    background-color: #e9ecef !important;
    -webkit-text-fill-color: #495057 !important;
  }
</style>
